module.exports = __webpack_public_path__ + "static/img/004@2x.07d60bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/erpManage/img/004@2x.png
// module id = LuD5
// module chunks = 10